'use client'

import { useEffect } from 'react'

import { usePathname } from 'next/navigation'

import i18n, { languages } from '@/core/i18n/setting'

export type SupportedLanguage = 'en' | 'fa' | 'ar' | 'fr'

export const useLanguageFromUrl = () => {
  const pathname = usePathname()

  useEffect(() => {
    const segments = pathname.split('/').filter(Boolean)
    const langFromPath = segments[0]

    // بررسی اینکه زبان از URL در لیست زبان‌های پشتیبانی شده باشه
    if (languages.includes(langFromPath as any)) {
      if (i18n.language !== langFromPath) {
        console.log('Changing language to:', langFromPath)
        i18n.changeLanguage(langFromPath)
      }
    }
  }, [pathname])

  return {
    currentLanguage: i18n.language as SupportedLanguage,
    isLanguageReady: i18n.isInitialized
  }
}
